import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { Chip, Typography } from '@material-ui/core';

function BNSChips({
  classes, onClick, bestNextSteps, color, label,
}) {
  return (
    <div className={classes.root}>
      <div className={classes.chipContainer}>
        <Typography>
          {label}
        </Typography>
        {bestNextSteps.resources().list().map(bns => (
          <Chip className={classes.chip} size="small" key={bns.attr('bestNextStepName')} label={bns.attr('bestNextStepName')} color={color} onClick={(e) => onClick(e, bns)} />
        ))}
      </div>
    </div>
  );
}

BNSChips.defaultProps = {
  color: 'primary',
  label: 'Recommended for you:',
};

BNSChips.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  bestNextSteps: PropTypes.object.isRequired,
  label: PropTypes.string,
  color: PropTypes.string,
};

export default withStyles(theme => ({
  root: {},
  chipContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}))(BNSChips);
